__turbopack_context__.v({
  "button": "yZO6KG_button",
  "label": "yZO6KG_label",
  "wrapper": "yZO6KG_wrapper",
});
